module.exports = __webpack_public_path__ + "img/section_4@2x.7b66abec.png";